import { round } from "lodash";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import { useRillContext } from "../../../../rill/RillReact/share/base";
import { formattedTarget } from "../../../../utils/actuals";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import { buildVideoModalUrl } from "../../../../utils/video-modal-url";

function ExerciseVideoLine({
  vidItem,
  exerciseToEdit,
  indexIndividualSet,
  setIndex,
  src = "/img/new-icons/play-white.svg",
  utcDate,
  primary,
  secondary,
  type,
  movement,
  set,
  outcomeEntry,
  setComment,
}) {
  const { locals } = useRillContext();
  const { fromMetric, activeUser } = locals;
  const { units, intensityMeasure } = activeUser || {};
  const isPowerlifting = type === "primary" || type === "secondary";
  const precision = units === "metric" ? 2 : 1;
  const userMetrics = units === "imperial" ? "lb" : "kg";
  const outcomeObj = outcomeEntry?.outcome || {};
  const rawLoad = outcomeObj.load;
  const formattedLoad =
    rawLoad && fromMetric
      ? `${round(fromMetric(rawLoad, units), precision)} ${userMetrics}`
      : 0;
  const setTarget =
    set && (rawLoad || outcomeObj.reps || outcomeObj.rpe)
      ? formattedTarget(
          outcomeObj,
          isPowerlifting,
          set.percentRepMax || undefined,
          units,
          formattedLoad,
          intensityMeasure,
          intensityMeasure !== "rpe",
          true
        ) || undefined
      : undefined;
  const setNumber = Number(setIndex) + 1;
  const {
    exerciseToEdit: queryExerciseToEdit,
    setIndex: querySetIndex,
    videoIndex: queryVideoIndex,
  } = locals.query;

  useEffect(() => {
    if (
      queryExerciseToEdit === exerciseToEdit &&
      querySetIndex === setIndex &&
      queryVideoIndex === indexIndividualSet
    ) {
      linkRef.current.click();
    }
  }, [
    queryExerciseToEdit,
    querySetIndex,
    queryVideoIndex,
    exerciseToEdit,
    setIndex,
    indexIndividualSet,
  ]);

  const linkRef = useRef(null);
  const lastComment = vidItem?.thread?.lastComment;
  const lastCommentUser =
    lastComment?.sender ??
    [locals.athlete, locals.activeUser].find(
      (user) => user?._id === lastComment?.senderId
    );
  const lastCommentUserAvatar = getAvatarUrl(lastCommentUser);
  const modalRedirect = buildVideoModalUrl({
    modalType: "exercise-set-video",
    video: vidItem,
    exerciseToEdit,
    setIndex,
    videoIndex: indexIndividualSet,
    utcDate,
    primary,
    secondary,
    type,
    movement,
    setNumber,
    setTarget,
    setComment,
  });
  const { t } = useTranslation("dashboard");
  return (
    <a ref={linkRef} href={modalRedirect} className="play-icon-wrapper">
      <SvgIcon
        classNames={`play-icon${vidItem?.thread ? " threaded" : ""}`}
        src={src}
        alt={t("exerciseVideoLine.playVideo")}
        noFilterOnLight={true}
      />
      {vidItem?.thread && (
        <img
          className="avatar"
          src={lastCommentUserAvatar}
          alt="last comment user avatar"
          loading="lazy"
        />
      )}
    </a>
  );
}

export default ExerciseVideoLine;
